import API_BASE_URL from "../../config";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

import PropTypes from "prop-types";
import {
  Container,
  Segment,
  Item,
  Divider,
  Button,
  Message,
  Form,
} from "semantic-ui-react";
import mindImg from "../../images/mind.svg";

const Main = ({ startQuiz }) => {
  const [full_name, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number] = useState("");
  const [company, setCompany] = useState("");
  const [role, setRole] = useState("");
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  const [token, setToken] = useState("");
  const [isCompanyReadonly, setIsCompanyReadonly] = useState(false);

  const [pastedLink, setPastedLink] = useState("");
  const [linkError, setLinkError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const companyParam = params.get("company");
    const tokenParam = params.get("token");

    if (companyParam) {
      setCompany(companyParam);
      setIsCompanyReadonly(true);
    }

    if (tokenParam) {
      setToken(tokenParam);
    }
  }, [location.search]);

  const handleLinkPaste = (value) => {
    setPastedLink(value);
    setLinkError("");

    if (!value) {
      setCompany("");
      setToken("");
      return;
    }

    try {
      const url = new URL(value);
      const companyParam = url.searchParams.get("company");
      const tokenParam = url.searchParams.get("token");

      if (companyParam) setCompany(companyParam);
      if (tokenParam) setToken(tokenParam);

      if (!companyParam || !tokenParam) {
        setLinkError("Bağlantıda şirket veya token bilgisi bulunamadı.");
      }
    } catch (e) {
      setLinkError("Lütfen geçerli bir bağlantı yapıştırın.");
    }
  };

  const isFormComplete =
    full_name && email && role && company && token && !linkError;

  const handleSubmit = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!full_name || !email || !role || !company || !token) {
      alert("Lütfen tüm alanları doldurun.");
      return;
    }

    if (!emailRegex.test(email)) {
      alert("Lütfen geçerli bir e-posta adresi girin.");
      return;
    }

    if (linkError) {
      alert("Lütfen geçerli bir bağlantı yapıştırın.");
      return;
    }

    setProcessing(true);
    setError(null);

    fetch(
      `${API_BASE_URL}/api/check-token-limit/?company=${encodeURIComponent(
        company,
      )}&token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`,
    )
      .then(async (res) => {
        if (!res.ok) {
          if (res.status === 403) {
            const body = await res.json().catch(() => ({}));
            if (body.error === "Lütfen doğru şirket mailinizi girin.") {
              throw new Error(body.error);
            }
            throw new Error("Geçersiz veya pasif bağlantı.");
          } else if (res.status === 409) {
            // Tamamlanmış testi olan kişi, yönetici izni olmadan tekrar çözemez (mesaj sunucudan)
            const body = await res.json().catch(() => ({}));
            throw new Error(
              body.error ||
                "Bu e-posta adresiyle test daha önce tamamlanmış. Tekrar çözebilmek için yöneticinizle iletişime geçin.",
            );
          } else if (res.status === 429) {
            throw new Error("Bu şirket için form kullanım limiti dolmuştur.");
          } else {
            throw new Error("Token doğrulama başarısız.");
          }
        }
        return res.json();
      })
      .then(() => {
        return fetch(
          `${API_BASE_URL}/api/questions/?company=${encodeURIComponent(
            company,
          )}&token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`,
        );
      })
      .then(async (res) => {
        const data = await res.json().catch(() => null);
        // Cevap soru listesi değilse (hata cevabı) teste başlanmaz
        if (!res.ok || !Array.isArray(data)) {
          throw new Error(data?.error || "Sorular alınamadı. Lütfen tekrar deneyin.");
        }
        return data;
      })
      .then((questions) => {
        // [{ id, text }, …] — sunucuda rastgele karıştırılmış sırayla
        startQuiz(questions, {
          full_name,
          email,
          phone_number,
          company,
          role,
          token,
        });
      })
      .catch((err) => {
        console.error(err);
        alert(err.message || "Bir hata oluştu.");
        setError(err);
      })
      .finally(() => setProcessing(false));
  };

  return (
    <Container>
      <Segment>
        <Item.Group divided>
          <Item>
            <Item.Image src={mindImg} />
            <Item.Content>
              <Item.Header>
                <h1>Kişilik Analiz Testi</h1>
              </Item.Header>
              {error && (
                <Message error>
                  <Message.Header>Error</Message.Header>
                  <p>{error.message}</p>
                </Message>
              )}
              <Divider />

              <Form>
                <Form.Input
                  label="Adınız Soyadınız"
                  placeholder="İsim Soyisim"
                  value={full_name}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                />
                <Form.Input
                  label="Şirket Maili"
                  placeholder="Şirket email adresiniz"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />

                <Form.Input
                  label="Pozisyonunuz"
                  placeholder="Pozisyon......"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  required
                />

                {isCompanyReadonly ? (
                  <Form.Input
                    label="Şirket Adı"
                    placeholder="Şirket Adı..."
                    value={company}
                    readOnly
                  />
                ) : (
                  <>
                    <Form.Input
                      label="Bağlantınızı yapıştırın"
                      placeholder="https://..."
                      value={pastedLink}
                      onChange={(e) => handleLinkPaste(e.target.value)}
                      error={!!linkError}
                      required
                    />
                    {linkError && (
                      <Message negative>
                        <p>{linkError}</p>
                      </Message>
                    )}
                    {company && !linkError && (
                      <p style={{ fontSize: "0.9rem", color: "#666" }}>
                        Şirket: <strong>{company}</strong>
                      </p>
                    )}
                  </>
                )}

                <Divider />
                <Button
                  primary
                  size="big"
                  icon="play"
                  labelPosition="left"
                  content={processing ? "Loading..." : "Başla"}
                  onClick={handleSubmit}
                  disabled={processing || !isFormComplete}
                />
              </Form>
            </Item.Content>
          </Item>
        </Item.Group>
      </Segment>
    </Container>
  );
};

Main.propTypes = {
  startQuiz: PropTypes.func.isRequired,
};

export default Main;
